import { useSetAnalyticsScreen } from '../../navigation';

export function TemplateAnalytics(props: { organizationId: string; templateId: string | null }) {
    const { organizationId, templateId } = props;
    useSetAnalyticsScreen(
        {
            screen: 'template',
            organization: organizationId,
            template: templateId,
        },
        [organizationId, templateId]
    );
    return null;
}
